import styled from 'styled-components'


const ButtonTagStyle = styled.div.attrs(props => ({ className: props.className, bgColor: props.bgColor }))`
    --padding:10px 20px;
    
    padding:var(--padding);
    color:var(--white);
    border-radius: 30px;
    background-color: ${props => props.bgColor};
    -webkite-appearance:none;
    transition:var(--trTime);
    cursor:pointer;
    text-transform:capitalize;
    margin-right: var(--spSize);
    margin-bottom: var(--spSize);

    .comp-title {
        color:inherit;
    }
    
    .black {
        color:var(--black);
    }

    &.smallTag {
        padding:4px var(--spSize);
    }

    &.bordered {
        border:2px solid var(--lightGrey);
        background-color: var(--white);
        color:var(--black);

        &:hover {
            border-color:var(--purple);
        }
        
        &.purple {
            border-color:var(--purple);
            background-color: var(--white);
            color:var(--purple);

            &:hover {
                background-color: var(--purple);
                color:var(--white);
            }
        }
    }
`
export default ButtonTagStyle
